<template>
  <drag-wrap
    v-if="compVisible"
    :visible="compVisible"
    modalId="roster"
    modalName="花名册"
  >
    <div
      class="comp-container__roster"
      :class="{ 'comp-container__roster__screen-share': isScreenShare }"
    >
      <div class="roster-drawer__title">
        <div class="title">{{ title }}</div>
        <div class="close" @click="handleClose">
          <img src="@saas/pages/assets/images/live/close-1.png" alt="" />
        </div>
      </div>
      <div class="roster-drawer__search can-not-drag-wrap">
        <div class="search-box">
          <i class="iconfont el-icon-search"></i>
          <el-input
            v-model="name"
            placeholder="请输入姓名"
            @input="handleSearch"
          ></el-input>
        </div>
        <div class="handle-box">
          <div class="handle-item">
            <!-- 全体开/闭麦 -->
            <img
              v-if="audioLoading"
              src="@saas/pages/assets/images/live/loading.png"
              alt=""
            />
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              :content="
                roomInfo.is_send_audio !== 1 ? '全部开麦克风' : '全部关麦克风'
              "
              placement="top"
            >
              <img :src="batchMicImg" @click="handleBatchMic" alt="" />
            </el-tooltip>
          </div>
          <div class="handle-item" v-if="roomInfo.mode != 1">
            <!-- 全体开/闭摄像头 -->
            <img
              v-if="videoLoading"
              src="@saas/pages/assets/images/live/loading.png"
              alt=""
            />
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              :content="
                roomInfo.is_send_video !== 1 ? '全部开摄像头' : '全部关摄像头'
              "
              placement="top"
            >
              <img :src="batchVideoImg" @click="handleBatchVideo" alt="" />
            </el-tooltip>
          </div>
          <div class="handle-item">
            <el-tooltip
              class="item"
              effect="dark"
              content="全部回到台下"
              placement="top"
            >
              <img
                @click="handleBatchStage()"
                src="@saas/pages/assets/images/live/step-down.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <!-- 全体开/闭禁言 -->
          <div class="handle-item">
            <img
              v-if="messageLoading"
              src="@saas/pages/assets/images/live/loading.png"
              alt=""
            />
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              :content="
                roomInfo.is_send_msg !== 1 ? '全部取消禁言' : '全部禁言'
              "
              placement="top"
            >
              <img :src="batchMessageImg" @click="handleBatchMessae" alt="" />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="roster-drawer__content can-not-drag-wrap" v-loading="loading">
        <div class="row title">
          <div class="col device"></div>
          <div class="col name">姓名</div>
          <div class="col handup">举手</div>
          <div class="col onstage">上台</div>
          <div class="col audio">语音</div>
          <div class="col video" v-if="roomInfo.mode != 1">视频</div>
          <div class="col whiteboard">
            白板
            <el-tooltip
              v-if="isScreenShare"
              class="item"
              effect="dark"
              content="需切换至白板界面方可生效"
              placement="top-start"
            >
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="col more">更多</div>
        </div>
        <div class="list-box">
          <div
            v-if="list.length > 0"
            class="scroll-box"
            v-infinite-scroll="getRosterData"
            :infinite-scroll-disabled="disabledLoad"
            :infinite-scroll-distance="20"
            :infinite-scroll-immediate="false"
          >
            <div
              v-for="item in displayList"
              :key="item.user_id"
              class="row"
              :class="{ offline: item.status !== 1 }"
            >
              <!-- 设备 -->
              <div class="col device">
                <img :src="getDeviceIcon(item)" alt="" />
              </div>
              <!--姓名 -->
              <div class="col name">
                <span
                  v-if="teacherAssistantRoles.includes(item.user_role)"
                  class="tag"
                  :class="{ 'teacher-tag': item.user_role === 1 }"
                  >{{ item.user_role === 1 ? "教师" : "助教" }}</span
                >
                <span class="name-text ellipsis">{{ item.nickname }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已禁言"
                  placement="top-start"
                >
                  <img
                    v-show="item.is_send_msg !== 1 && item.status === 1"
                    src="@saas/pages/assets/images/live/mute.png"
                    alt=""
                  />
                </el-tooltip>
                <template v-if="item.is_permanent_remove === 1">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="已移出，不可再次进入"
                    placement="top-start"
                  >
                    <img
                      src="@saas/pages/assets/images/live/tanhao.png"
                      alt=""
                    />
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="移入"
                    placement="top-start"
                  >
                    <img
                      style="cursor: pointer"
                      src="@saas/pages/assets/images/live/move-in.png"
                      @click="handleMoveInStudent(item)"
                      alt=""
                    />
                  </el-tooltip>
                </template>
              </div>
              <!--举手 -->

              <div class="col handup">
                <img
                  v-if="item.isHandUp"
                  src="@saas/pages/assets/images/live/hand-color.png"
                  alt=""
                />
              </div>
              <!--上台 -->
              <div class="col onstage">
                <img
                  :src="getUpstageStateIcon(item)"
                  alt=""
                  @click="changeStageStatus(item)"
                />
              </div>
              <!--音频 -->
              <div class="col audio">
                <img
                  :src="getAudioIcon(item)"
                  alt=""
                  @click="changeAudioStatus(item)"
                />
              </div>
              <!-- 视频 -->
              <div class="col video" v-if="roomInfo.mode != 1">
                <img
                  :src="getVideoIcon(item)"
                  alt=""
                  @click="changeVideoStatus(item)"
                />
              </div>
              <!-- 白板 -->
              <div class="col whiteboard">
                <img
                  :src="getWhiteboardIcon(item)"
                  alt=""
                  @click="changeWhiteBoardStatus(item)"
                />
              </div>
              <div class="col more">
                <img
                  v-if="
                    item.status !== 1 ||
                    item.user_role === 1 ||
                    (item.user_role === 2 && roomInfo.isAssistant)
                  "
                  src="@saas/pages/assets/images/live/more-offline.png"
                  alt=""
                />
                <el-dropdown v-else @command="(type) => handleItem(item, type)">
                  <img src="@saas/pages/assets/images/live/more-1.png" alt="" />
                  <el-dropdown-menu
                    slot="dropdown"
                    class="roster-dropdown-menu"
                  >
                    <el-dropdown-item
                      v-if="item.is_send_msg === 1"
                      :command="'mute'"
                    >
                      禁言
                    </el-dropdown-item>
                    <el-dropdown-item v-else :command="'cancelMute'">
                      取消禁言
                    </el-dropdown-item>
                    <el-dropdown-item :command="'remove'" class="remove">
                      移出
                    </el-dropdown-item>
                    <el-dropdown-item command="rename">
                      修改课中昵称
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <empty class="empty" v-else />
        </div>
      </div>
      <!-- 移出课堂确认弹窗 -->
      <move-out-class
        ref="moveOutClass"
        :studentInfo="handleStudentData"
        @moveOutSuccess="onMoveOutSuccess"
      ></move-out-class>
    </div>
  </drag-wrap>
</template>

<script>
// loading图标
const LOADING_IMG = require("@saas/pages/assets/images/live/loading.png");
// 批量麦克风图标
const BATCH_MIC_OPEN_IMG = require("@saas/pages/assets/images/live/mic-close.png");
const BATCH_MIC_CLOSE_IMG = require("@saas/pages/assets/images/live/close-mic.png");
// 批量摄像头图标
const BATCH_VIDEO_OPEN_IMG = require("@saas/pages/assets/images/live/video-close.png");
const BATCH_VIDEO_CLOSE_IMG = require("@saas/pages/assets/images/live/close-video.png");
// 批量禁言图标
const BATCH_MESSAGE_OPEN_IMG = require("@saas/pages/assets/images/live/mute.png");
const BATCH_MESSAGE_CLOSE_IMG = require("@saas/pages/assets/images/live/close-mute.png");
// 设备图标映射与分组使用 Set，避免模板渲染时频繁创建临时数组
const DEVICE_ICON = {
  monitor: require("@saas/pages/assets/images/live/monitor.png"),
  phone: require("@saas/pages/assets/images/live/phone.png"),
  pad: require("@saas/pages/assets/images/live/pad.png"),
  sim: require("@saas/pages/assets/images/live/simcard.png"),
  info: require("@saas/pages/assets/images/live/info-circle.png"),
};
const MONITOR_SET = new Set([1, 2]);
const PHONE_SET = new Set([3, 4]);
const PAD_SET = new Set([5]);
const SIM_SET = new Set([6]);

// 上台状态图标映射
const UPSTAGE_ICON = {
  open: require("@saas/pages/assets/images/live/step-down-open.png"),
  close: require("@saas/pages/assets/images/live/step-down-close.png"),
  disabled: require("@saas/pages/assets/images/live/step-down-offline.png"),
  loading: LOADING_IMG,
};
// 音频状态图标映射
const AUDIO_ICON = {
  open: require("@saas/pages/assets/images/live/mic-open.png"),
  close: require("@saas/pages/assets/images/live/mic-close.png"),
  disabled: require("@saas/pages/assets/images/live/mic-offline.png"),
  loading: LOADING_IMG,
};
// 视频状态图标映射
const VIDEO_ICON = {
  open: require("@saas/pages/assets/images/live/video-open.png"),
  close: require("@saas/pages/assets/images/live/video-close.png"),
  disabled: require("@saas/pages/assets/images/live/video-offline.png"),
  loading: LOADING_IMG,
};
// 白板状态图标映射
const WHITEBOARD_ICON = {
  open: require("@saas/pages/assets/images/live/whiteboard-open.png"),
  close: require("@saas/pages/assets/images/live/whiteboard-close.png"),
  disabled: require("@saas/pages/assets/images/live/whiteboard-offline.png"),
  loading: LOADING_IMG,
};

import {
  getRoster,
  updateRoomStatus,
  setUserRole,
  removeUser,
  getRoomInfo,
} from "@saas/server-api/src/live-sdk";
import { mapMutations, mapState } from "vuex";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import MoveOutClass from "../../dialog/MoveOutClass.vue";
import { DragWrap } from "@saas/components";
import screenShare from "../../mixins/screen-share";
import handleSelf from "../../mixins/handle-self";
import handleRemote from "../../mixins/handle-remote";
import { debounce } from "@saas/components/src/utils/debounce-async";
import {
  isAssistant,
  isTeacher,
  hasUpDownStagePermission,
  hasAudioPermission,
  hasVideoPermission,
  hasWhiteboardPermission,
} from "../../utils/index.js";
import { BatchUpdate } from "../../utils/batch-update.js";
export default {
  mixins: [screenShare, handleSelf, handleRemote],
  components: {
    DragWrap,
    MoveOutClass,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      compVisible: false,
      isElectron: window.isElectron,
      list: [],
      name: "",
      pageInfo: {
        pageSize: 100,
        page: 1,
        total: 1,
      },
      loading: false,
      handleStudentData: {},
      messageLoading: false,
      audioLoading: false,
      videoLoading: false,
      eventBusHandlers: {},
      imServiceHandlers: {},
      liveServiceHandlers: {},
      handUpTimeoutMap: new Map(),
      batchUpdater: null,
    };
  },
  computed: {
    title() {
      return `花名册（${this.onlineCount}/${this.roomInfo.enrollment_count}）`;
    },
    ...mapState("live", [
      "isReady",
      "layout",
      "liveService",
      "imService",
      "deviceSwtich",
      "roomInfo",
      "allMemberStatus",
      "onlineCount",
      "showRaiseHand",
      "userStatus",
      "videoPermission",
      "audioPermission",
      "screenShareStatus",
      "memberOnlineStatus",
      "allMemberStatusMap",
    ]),
    // 教师和助教角色
    teacherAssistantRoles: () => [1, 2],
    disabledLoad() {
      if (this.loading) {
        return true;
      }
      return this.pageInfo.total <= this.list.length;
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
    batchMicImg() {
      return this.roomInfo.is_send_audio !== 1
        ? BATCH_MIC_OPEN_IMG
        : BATCH_MIC_CLOSE_IMG;
    },
    batchVideoImg() {
      return this.roomInfo.is_send_video !== 1
        ? BATCH_VIDEO_OPEN_IMG
        : BATCH_VIDEO_CLOSE_IMG;
    },
    batchMessageImg() {
      return this.roomInfo.is_send_msg !== 1
        ? BATCH_MESSAGE_OPEN_IMG
        : BATCH_MESSAGE_CLOSE_IMG;
    },
    displayList() {
      if (!this.list || this.list.length === 0) return [];
      const online = [];
      const offline = [];

      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (item.status === 1) {
          online.push(item);
        } else {
          offline.push(item);
        }
      }
      return online.concat(offline);
    },
  },
  watch: {
    liveService: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.clearLiveServiceEventBus();
        }
        if (newVal) {
          this.initLiveServiceEventBus();
        }
      },
      immediate: true,
    },
    imService: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.clearImServiceEventBus();
        }
        if (newVal) {
          this.initImServiceEventBus();
        }
      },
      immediate: true,
    },
    visible(val) {
      this.compVisible = val;
      if (val) {
        this.getRoomInfo();
        this.list = [];
        this.pageInfo.page = 1;
        this.pageInfo.total = 1; // 重置总数
        this.getRosterData();
      }
    },
    "userStatus.audio_state": {
      handler(newVal, oldVal) {
        this.batchUpdater.queue(this.userStatus.user_id, {
          audio_state: newVal,
        });
      },
    },
    "userStatus.video_state": {
      handler(newVal, oldVal) {
        this.batchUpdater.queue(this.userStatus.user_id, {
          video_state: newVal,
        });
      },
    },
  },
  created() {
    this.batchUpdater = new BatchUpdate({
      vueInstance: this,
      findItemCallback: (userId) => {
        return this.list.find((item) => item.user_id === userId);
      },
    });
  },
  mounted() {
    this.initEventBus();
  },
  beforeDestroy() {
    this.clearEventBus();
    this.clearImServiceEventBus();
    this.clearLiveServiceEventBus();
    this.clearHandUpTimeoutMap();
    if (this.batchUpdater) {
      this.batchUpdater.clear();
    }
  },
  methods: {
    ...mapMutations("live", [
      "setRoomInfo",
      "setUserStatus",
      "setShowRoster",
      "setShowChangeNickname",
    ]),
    // 获取设备图标，优先根据在线状态返回"info"，减少分支判断
    getDeviceIcon(item) {
      if (item.status !== 1) {
        return DEVICE_ICON.info;
      }
      const device = item.device;
      if (MONITOR_SET.has(device)) return DEVICE_ICON.monitor;
      if (PHONE_SET.has(device)) return DEVICE_ICON.phone;
      if (PAD_SET.has(device)) return DEVICE_ICON.pad;
      if (SIM_SET.has(device)) return DEVICE_ICON.sim;
      return DEVICE_ICON.info;
    },
    // 获取人员上台图标
    getUpstageStateIcon(item) {
      if (
        item.status !== 1 ||
        !hasUpDownStagePermission(item.user_id, this.roomInfo)
      ) {
        return UPSTAGE_ICON.disabled;
      }
      if (item.stageLoading) return UPSTAGE_ICON.loading;
      if (item.is_up_stage === 1) return UPSTAGE_ICON.open;
      return UPSTAGE_ICON.close;
    },
    // 获取音频图标
    getAudioIcon(item) {
      if (
        item.status !== 1 ||
        item.is_up_stage !== 1 ||
        !hasAudioPermission(item.user_id, this.roomInfo)
      ) {
        // 不在线或者不在台上是禁止操作
        return AUDIO_ICON.disabled;
      }
      if (item.audioLoading) return AUDIO_ICON.loading;
      if (item.audio_state === 1) return AUDIO_ICON.open;
      return AUDIO_ICON.close;
    },
    // 获取视频图标
    getVideoIcon(item) {
      if (
        item.status !== 1 ||
        item.is_up_stage !== 1 ||
        !hasVideoPermission(item.user_id, this.roomInfo)
      ) {
        return VIDEO_ICON.disabled;
      }
      if (item.videoLoading) return VIDEO_ICON.loading;
      if (item.video_state === 1) return VIDEO_ICON.open;
      return VIDEO_ICON.close;
    },
    // 获取白板图标
    getWhiteboardIcon(item) {
      if (
        item.status !== 1 ||
        !hasWhiteboardPermission(item.user_id, this.roomInfo)
      ) {
        return WHITEBOARD_ICON.disabled;
      }
      if (item.whiteLoading) return WHITEBOARD_ICON.loading;
      if (item.is_whiteboard === 1) return WHITEBOARD_ICON.open;
      return WHITEBOARD_ICON.close;
    },
    // 初始化事件总线
    initEventBus() {
      // 保存回调引用，方便清理
      this.eventBusHandlers = {
        "move-out-success": (res) => {
          const { userId, isNeverJoinAgain } = res;
          this.batchUpdater.queue(userId, {
            is_permanent_remove: isNeverJoinAgain ? 1 : 2,
            status: 0,
          });
        },
        downstage: (res) => {
          this.onDownStage(res, this.userInfo.user_id);
        },
        videoMute: (res) => {
          this.onReciveVideoMute(res, this.userInfo.user_id);
        },
        audioMute: (res) => {
          this.onReciveAudioMute(res, this.userInfo.user_id);
        },
        whiteboard: (res) => {
          this.onReciveWhiteboard(res, this.userInfo.user_id);
        },
        updateNickname: (res) => {
          this.onReciveUpdateNickname(res);
        },
      };
      // 注册监听
      Object.keys(this.eventBusHandlers).forEach((eventName) => {
        EventBus.$on(eventName, this.eventBusHandlers[eventName]);
      });
    },
    // 清理事件总线
    clearEventBus() {
      Object.keys(this.eventBusHandlers).forEach((eventName) => {
        EventBus.$off(eventName, this.eventBusHandlers[eventName]);
      });
      this.eventBusHandlers = {};
    },
    // 初始化imService事件总线
    initImServiceEventBus() {
      this.imServiceHandlers = {
        recvMGLiveRoomCustomMsg: (res) => {
          this.onReciveCustomMessage(res);
        },
      };
      // 注册监听
      Object.keys(this.imServiceHandlers).forEach((eventName) => {
        this.imService.on(eventName, this.imServiceHandlers[eventName]);
      });
    },
    // 清理imService事件总线
    clearImServiceEventBus() {
      if (this.imServiceHandlers && this.imService) {
        Object.keys(this.imServiceHandlers).forEach((eventName) => {
          this.imService.off(eventName, this.imServiceHandlers[eventName]);
        });
        this.imServiceHandlers = {};
      }
    },
    // 初始化liveService事件总线
    initLiveServiceEventBus() {
      this.liveServiceHandlers = {
        remoteUserEnterRoom: (res) => {
          this.onReciveUserEnterRoom(res);
        },
        remoteUserLeaveRoom: (res) => {
          this.onReciveUserLeaveRoom(res);
        },
        connectionRecovery: (res) => {
          this.onConnectionRecovery();
        },
      };
      // 注册监听
      Object.keys(this.liveServiceHandlers).forEach((eventName) => {
        this.liveService.on(eventName, this.liveServiceHandlers[eventName]);
      });
    },
    // 清理liveService事件总线
    clearLiveServiceEventBus() {
      if (this.liveServiceHandlers && this.liveService) {
        Object.keys(this.liveServiceHandlers).forEach((eventName) => {
          this.liveService.off(eventName, this.liveServiceHandlers[eventName]);
        });
        this.liveServiceHandlers = {};
      }
    },
    onReciveCustomMessage(res) {
      const { data, userId } = res;
      if (data.type === "userStatus") {
        this.onReciveUserStatusChange(data.data);
      } else if (data.type === "member_hand_up") {
        this.onReciveUserHandUp(data.data);
      } else if (data.type === "audioMute") {
        this.onReciveAudioMute(data.data, userId);
      } else if (data.type === "videoMute") {
        this.onReciveVideoMute(data.data, userId);
      } else if (data.type === "messageMute") {
        this.onReciveMessageMute(data.data, userId);
      } else if (data.type === "xhRemoteEnterRoom") {
        this.onReciveXhRemoteEnterRoom(data.data);
      } else if (data.type === "downstage") {
        this.onDownStage(data.data, userId);
      } else if (data.type === "whiteboard") {
        this.onReciveWhiteboard(data.data);
      } else if (data.type === "initUserStatus") {
        this.onReciveInitUserStatus(data.data);
      } else if (data.type === "updateNickname") {
        this.onReciveUpdateNickname(data.data);
      }
      uploadLiveLog({
        message: "收到自定义消息",
        level: "info",
        tag: "callback",
        extra: {
          component: "Roster",
          type: data.type,
          fromUserId: userId,
          data: data.data,
        },
      });
    },
    onConnectionRecovery() {
      if (
        this.roomInfo.id &&
        this.liveService.isEnterRoomSuccess &&
        this.compVisible
      ) {
        this.list = [];
        this.pageInfo.page = 1;
        this.pageInfo.total = 1; // 重置总数
        this.getRosterData();
      }
    },
    // 当人员状态更新
    onReciveUserStatusChange(data) {
      const userId = data.user_id;
      this.batchUpdater.queue(userId, {
        audio_state: data.audio_state,
        video_state: data.video_state,
      });
    },
    // 当有人进入房间
    onReciveUserEnterRoom(res) {
      const index = this.list.findIndex((item) => item.user_id === res.userID);
      if (index !== -1) {
        this.batchUpdater.queue(res.userID, {
          status: 1,
        });
      } else {
        if (this.compVisible) {
          this.pageInfo.page = 1;
          this.pageInfo.total = 1;
          this.list = [];
          this.getRosterData();
        }
      }
    },
    // 当有人离开房间
    onReciveUserLeaveRoom(res) {
      this.batchUpdater.queue(res.userID, {
        status: 0,
      });
    },
    // 当有人举手
    onReciveUserHandUp(data) {
      const { user_id } = data;
      const index = this.list.findIndex((item) => item.user_id === user_id);
      if (index !== -1) {
        this.batchUpdater.queue(user_id, {
          isHandUp: true,
        });
        if (this.handUpTimeoutMap.has(user_id)) {
          clearTimeout(this.handUpTimeoutMap.get(user_id));
        }
        const timeId = setTimeout(() => {
          this.batchUpdater.queue(user_id, {
            isHandUp: false,
          });
          this.handUpTimeoutMap.delete(user_id);
        }, 10000);
        this.handUpTimeoutMap.set(user_id, timeId);
      }
    },
    onReciveAudioMute(data, fromUserId) {
      const { userId, isMute } = data;
      if (userId === "*") {
        // 全员关闭麦克风/全员打开麦克风
        this.setRoomInfo({
          is_send_audio: isMute ? 2 : 1,
        });
        if (isMute) {
          if (isTeacher(fromUserId)) {
            // 老师操作全员关闭麦克风.除了老师其他人都关闭麦克风
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role !== 1) {
                this.batchUpdater.queue(item.user_id, {
                  audio_state: 2,
                });
              }
            });
          } else if (isAssistant(fromUserId)) {
            // 助教操作全员关闭麦克风,学生都关闭麦克风
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role === 3) {
                this.batchUpdater.queue(item.user_id, {
                  audio_state: 2,
                });
              }
            });
          }
        }
      } else {
        if (fromUserId === this.userInfo.user_id && fromUserId === userId) {
          // 自己操作自己
          console.log(
            "new_live_roster_onReciveAudioMute__自己操作自己",
            fromUserId,
            userId
          );
          this.batchUpdater.queue(fromUserId, {
            audio_state: isMute ? 2 : 1,
          });
        } else {
          if (isMute) {
            this.batchUpdater.queue(userId, {
              audio_state: 2,
            });
          }
        }
      }
    },
    onReciveVideoMute(data, fromUserId) {
      const { userId, isMute } = data;
      if (userId === "*") {
        // 全员关闭摄像头/全员打开摄像头
        this.setRoomInfo({
          is_send_video: isMute ? 2 : 1,
        });
        if (isMute) {
          if (isTeacher(fromUserId)) {
            // 老师操作全员关闭摄像头.除了老师其他人都关闭摄像头
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role !== 1) {
                this.batchUpdater.queue(item.user_id, {
                  video_state: 2,
                });
              }
            });
          } else if (isAssistant(fromUserId)) {
            // 助教操作全员关闭摄像头,学生都关闭摄像头
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role === 3) {
                this.batchUpdater.queue(item.user_id, {
                  video_state: 2,
                });
              }
            });
          }
        }
      } else {
        if (fromUserId === this.userInfo.user_id && fromUserId === userId) {
          // 自己操作自己
          this.batchUpdater.queue(fromUserId, {
            video_state: isMute ? 2 : 1,
          });
        } else {
          if (isMute) {
            this.batchUpdater.queue(userId, {
              video_state: 2,
            });
          }
        }
      }
    },
    // 打开或者关闭消息
    onReciveMessageMute(data, fromUserId) {
      const { userId, isMute } = data;
      if (userId === "*") {
        // 全员关闭摄像头
        if (isTeacher(fromUserId)) {
          // 老师操作全员关闭消息
          this.list.forEach((item) => {
            if (item.user_role !== 1) {
              item.is_send_msg = isMute ? 2 : 1;
            }
          });
        } else if (isAssistant(fromUserId)) {
          // 助教操作全员关闭消息
          this.list.forEach((item) => {
            if (item.user_role === 3) {
              item.is_send_msg = isMute ? 2 : 1;
            }
          });
        }
        this.setRoomInfo({
          is_send_msg: isMute ? 2 : 1,
        });
      } else {
        // 单个用户关闭消息
        this.batchUpdater.queue(userId, {
          is_send_msg: isMute ? 2 : 1,
        });
      }
    },
    onReciveXhRemoteEnterRoom(data) {
      const { userId } = data;
      // 有人进入房间
      this.batchUpdater.queue(userId, {
        status: 1,
      });
    },
    onReciveUpdateNickname(data) {
      const { userId, nickname } = data;
      this.batchUpdater.queue(userId, {
        nickname: nickname,
      });
    },
    // 有人上下台
    onDownStage(data, fromUserId) {
      const { userId, isDown } = data;
      if (userId === "*") {
        // 全员下台
        if (isTeacher(fromUserId)) {
          // 老师操作全员下台.除了老师其他人都下台
          this.list.forEach((item) => {
            if (item.status === 1 && item.user_role !== 1) {
              this.batchUpdater.queue(item.user_id, {
                is_up_stage: 2,
              });
            }
          });
        } else if (isAssistant(fromUserId)) {
          // 助教操作全员下台,学生都下台
          this.list.forEach((item) => {
            if (item.status === 1 && item.user_role === 3) {
              this.batchUpdater.queue(item.user_id, {
                is_up_stage: 2,
              });
            }
          });
        }
      } else {
        // 单个用户上下台
        this.batchUpdater.queue(userId, {
          is_up_stage: isDown ? 2 : 1,
        });
        if (!isDown && this.roomInfo.up_stage_whiteboard === 1) {
          // 上台开启白板权限
          this.batchUpdater.queue(userId, {
            is_whiteboard: 1,
          });
        }
      }
    },
    // 收到白板
    onReciveWhiteboard(data) {
      const { userId, isWhiteboard } = data;
      this.batchUpdater.queue(userId, {
        is_whiteboard: isWhiteboard ? 1 : 2,
      });
    },

    // 初始化用户状态
    onReciveInitUserStatus(data) {
      const { user_id } = data;
      this.batchUpdater.queue(user_id, {
        is_up_stage: data.is_up_stage,
      });
    },
    // 获取人员上台状态
    getUpstageState(item) {
      if (
        item.status !== 1 ||
        !hasUpDownStagePermission(item.user_id, this.roomInfo)
      ) {
        // 不在线或者没有操作权限
        return "disabled";
      } else if (item.stageLoading) {
        // loading
        return "loading";
      } else if (item.is_up_stage === 1) {
        // 在台上
        return "open";
      } else {
        // 在台下
        return "close";
      }
    },
    // 获取音频状态 disabled: 禁止操作, open: 打开, close: 关闭, loading
    getAudioState(item) {
      if (
        item.status !== 1 ||
        item.is_up_stage !== 1 ||
        !hasAudioPermission(item.user_id, this.roomInfo)
      ) {
        // 不在线或者不在台上是禁止操作
        return "disabled";
      } else if (item.audioLoading) {
        return "loading";
      } else if (item.audio_state === 1) {
        return "open";
      } else {
        return "close";
      }
    },
    // 获取视频频状态 disabled: 禁止操作, open: 打开, close: 关闭, loading
    getVideoState(item) {
      if (
        item.status !== 1 ||
        item.is_up_stage !== 1 ||
        !hasVideoPermission(item.user_id, this.roomInfo)
      ) {
        // 不在线或者不在台上是禁止操作
        return "disabled";
      } else if (item.videoLoading) {
        return "loading";
      } else if (item.video_state === 1) {
        return "open";
      } else {
        return "close";
      }
    },
    // 获取白板状态 disabled: 禁止操作, open: 打开, close: 关闭, loading
    getWhiteboardState(item) {
      if (
        item.status !== 1 ||
        !hasWhiteboardPermission(item.user_id, this.roomInfo)
      ) {
        // 不在线禁止操作
        return "disabled";
      } else if (item.whiteLoading) {
        return "loading";
      } else if (item.is_whiteboard === 1) {
        return "open";
      } else {
        return "close";
      }
    },
    handleSearch: debounce(function () {
      this.list = [];
      this.pageInfo.page = 1;
      this.pageInfo.total = 1; // 重置总数，避免disabledLoad计算错误
      this.getRosterData();
    }, 500),
    showHandup(data) {
      if (data.user_role !== 3) {
        // 老师和助教不展示举手
        return false;
      } else if (data.status !== 1) {
        // 非在线不展示举手
        return false;
      } else {
        if (data.hand_up_time) {
          const timeout = Date.now() - data.hand_up_time * 1000;
          return timeout < 10000 && timeout > 0;
        } else {
          return false;
        }
      }
    },
    // 操作全体麦克风
    handleBatchMic: debounce(
      function () {
        const type = this.roomInfo.is_send_audio !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体麦克风" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_mic",
            type: type,
          },
        });
        this.audioLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteAudio(status)
          .then((res) => {
            if (this.roomInfo.isTeacher && status === 2) {
              this.list.forEach((item) => {
                if (item.status === 1 && item.user_role !== 1) {
                  this.batchUpdater.queue(item.user_id, {
                    audio_state: 2,
                  });
                }
              });
            } else if (this.roomInfo.isAssistant && status === 2) {
              this.list.forEach((item) => {
                if (item.status === 1 && item.user_role === 3) {
                  this.batchUpdater.queue(item.user_id, {
                    audio_state: 2,
                  });
                }
              });
            }
            this.audioLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体麦克风" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_mic",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.audioLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体麦克风" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_mic",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),
    // 操作全体摄像头
    handleBatchVideo: debounce(
      function () {
        const type = this.roomInfo.is_send_video !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体摄像头" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_video",
            type: type,
          },
        });
        this.videoLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteVideo(status)
          .then((res) => {
            if (this.roomInfo.isTeacher && status === 2) {
              this.list.forEach((item) => {
                if (item.status === 1 && item.user_role !== 1) {
                  this.batchUpdater.queue(item.user_id, {
                    video_state: 2,
                  });
                }
              });
            }
            if (this.roomInfo.isAssistant && status === 2) {
              this.list.forEach((item) => {
                if (item.status === 1 && item.user_role === 3) {
                  this.batchUpdater.queue(item.user_id, {
                    video_state: 2,
                  });
                }
              });
            }
            this.videoLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体摄像头" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_video",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.videoLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体摄像头" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_video",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),
    // 全体下台
    handleBatchStage: debounce(function () {
      uploadLiveLog({
        message: "用户点击全体下台",
        level: "info",
        tag: "userAction",
        extra: {
          component: "Roster",
          action: "click_roster_batch_stage",
        },
      });
      this.handleAllRemoteDownStage()
        .then(() => {
          if (this.roomInfo.isTeacher) {
            // 老师操作全员下台，除了老师其他人都下台
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role !== 1) {
                this.batchUpdater.queue(item.user_id, {
                  is_up_stage: 2,
                });
              }
            });
          } else if (this.roomInfo.isAssistant) {
            // 助教操作全员下台，学生都下台
            this.list.forEach((item) => {
              if (item.status === 1 && item.user_role === 3) {
                this.batchUpdater.queue(item.user_id, {
                  is_up_stage: 2,
                });
              }
            });
          }
          uploadLiveLog({
            message: "用户点击全体下台成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_stage",
            },
          });
        })
        .catch((err) => {
          uploadLiveLog({
            message: "用户点击全体下台失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_stage",
              error: err?.message || err,
            },
          });
        });
    }, 300),
    // 操作全体消息 禁言/解除禁言
    handleBatchMessae: debounce(
      function () {
        const type = this.roomInfo.is_send_msg !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体消息" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_message",
            type: type,
          },
        });
        this.messageLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteMessage(status)
          .then((res) => {
            this.messageLoading = false;
            if (this.roomInfo.isTeacher) {
              // 老师操作全员禁言，除了老师其他人都禁言
              this.list.forEach((item) => {
                if (item.user_role !== 1) {
                  this.batchUpdater.queue(item.user_id, {
                    is_send_msg: status,
                  });
                }
              });
            } else if (this.roomInfo.isAssistant) {
              // 助教操作全员禁言，学生都禁言
              this.list.forEach((item) => {
                if (item.user_role === 3) {
                  this.batchUpdater.queue(item.user_id, {
                    is_send_msg: status,
                  });
                }
              });
            }
            uploadLiveLog({
              message:
                "用户点击全体消息" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_message",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.messageLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体消息" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_message",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),

    handleClose() {
      uploadLiveLog({
        message: "用户点击花名册关闭按钮",
        level: "info",
        tag: "userAction",
        extra: {
          component: "Roster",
          action: "click_roster_close",
        },
      });

      this.$emit("close");
      this.setShowRoster(false);
      this.compVisible = false;
      this.$emit("update:visible", false);
    },
    getRosterData() {
      this.loading = true;
      const currentPage = this.pageInfo.page;
      getRoster({
        room_id: this.roomInfo.id,
        nickname: this.name,
        page_no: currentPage,
        page_size: this.pageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            // 只有在成功获取数据后才增加页码
            if (currentPage === 1) {
              this.list = [];
            }
            this.pageInfo.page++;
            this.pageInfo.total = res.data.total;
            const list = [...this.list, ...(res.data?.list || [])];
            this.dealListAfterGetData(list);
            uploadLiveLog({
              message: "获取花名册数据成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "get_roster_data",
                page: currentPage,
                pageSize: this.pageInfo.pageSize,
                total: this.pageInfo.total,
                list: this.list,
              },
            });
          } else {
            this.$darkMessage.error(res.message);
            uploadLiveLog({
              message: "获取花名册数据失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "get_roster_data",
                error: res.message,
              },
            });
          }
        })
        .catch((error) => {
          // 网络错误或其他异常
          uploadLiveLog({
            message: "获取花名册数据异常",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "get_roster_data",
              error: error?.message || error,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleItem(item = {}, type) {
      uploadLiveLog({
        message: "用户点击花名册成员" + type,
        level: "info",
        tag: "userAction",
        extra: {
          component: "Roster",
          action: "click_roster_item",
          type: type,
          item: item,
        },
      });
      this.handleStudentData = { ...item };
      if (type === "mute") {
        // 禁言
        this.changeMessageStatus(item, 2);
      } else if (type === "cancelMute") {
        // 取消禁言
        this.changeMessageStatus(item, 1);
      } else if (type === "remove") {
        // 移出
        this.$refs.moveOutClass.open();
      } else if (type === "rename") {
        // 修改nickname
        this.setShowChangeNickname({
          visible: true,
          info: {
            userId: item.user_id,
            nickname: item.nickname,
          },
        });
      }
    },
    // 操作某人发消息的权限
    changeMessageStatus(student, status) {
      this.handleRemoteMessage(student.user_id, status)
        .then(() => {
          this.batchUpdater.queue(student.user_id, {
            is_send_msg: status,
          });
          uploadLiveLog({
            message: status === 1 ? "解除某人禁言成功" : "禁言某人成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_message_status",
              type: status,
              targetUser: student,
            },
          });
        })
        .catch((err) => {
          this.$darkMessage.error(err.message);
          uploadLiveLog({
            message: status === 1 ? "解除某人禁言的权限失败" : "禁言某人失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_message_status",
              type: status,
              targetUser: student,
            },
          });
        });
    },
    // 操作某人的白板权限
    changeWhiteBoardStatus(student) {
      const currentState = this.getWhiteboardState(student);
      let status = 0;
      if (currentState === "disabled" || currentState === "loading") {
        return;
      } else if (currentState === "open") {
        status = 2;
      } else if (currentState === "close") {
        status = 1;
      }
      this.$set(student, "whiteLoading", true);
      this.handleRemoteWhiteboard(student.user_id, status)
        .then(() => {
          student.whiteLoading = false;
          student.is_whiteboard = status;
          uploadLiveLog({
            message: status === 1 ? "打开某人白板成功" : "关闭某人白板成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_whiteboard_status",
              type: status,
              targetUser: student,
            },
          });
        })
        .catch((err) => {
          student.whiteLoading = false;
          uploadLiveLog({
            message: status === 1 ? "打开某人白板失败" : "关闭某人白板失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_whiteboard_status",
              type: status,
              targetUser: student,
              error: err?.message || err,
            },
          });
        });
    },
    // 操作某人上下台
    changeStageStatus(student) {
      const state = this.getUpstageState(student);
      let status = 0;
      if (state === "disabled" || state === "loading") {
        return;
      } else if (state === "open") {
        status = 2;
      } else if (state === "close") {
        status = 1;
      }
      this.$set(student, "stageLoading", true);
      this.handleRemoteUpDown(student.user_id, status)
        .then(() => {
          student.is_up_stage = status;
          student.stageLoading = false;
          if (
            student.is_up_stage === 1 &&
            this.roomInfo.up_stage_whiteboard === 1
          ) {
            // 上台开启白板权限
            student.is_whiteboard = 1;
          }
          uploadLiveLog({
            message: status === 1 ? "操作某人上台成功" : "操作某人下台成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_stage_status",
              type: status,
              targetUser: student,
            },
          });
        })
        .catch((err) => {
          student.stageLoading = false;
          uploadLiveLog({
            message: status === 1 ? "操作某人上台失败" : "操作某人下台失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "change_stage_status",
              type: status,
              targetUser: student,
              error: err?.message || err,
            },
          });
        });
    },
    // 操作某人麦克分
    changeAudioStatus(student) {
      const currentState = this.getAudioState(student);
      let status = 0;
      if (currentState === "disabled" || currentState === "loading") {
        return;
      } else if (currentState === "open") {
        status = 2;
      } else if (currentState === "close") {
        status = 1;
      }
      this.$set(student, "audioLoading", true);
      // 如果当前用户是老师，操作自己的麦克风 或者当前用户是助教操作自己的麦克风 直接更新状态就行
      if (
        student.user_id === this.userInfo.user_id &&
        (this.roomInfo.isTeacher || this.roomInfo.isAssistant)
      ) {
        const isMute = status === 2;
        this.handleSelfMic(isMute)
          .then(() => {
            student.audioLoading = false;
            student.audio_state = status;
            uploadLiveLog({
              message: !isMute ? "打开自己麦克风成功" : "关闭自己麦克风成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_audio_status",
                type: status,
                targetUser: student,
              },
            });
          })
          .catch((error) => {
            console.error("操作自己麦克风失败:", error);
            student.audioLoading = false;
            uploadLiveLog({
              message: !isMute ? "打开自己麦克风失败" : "关闭自己麦克风失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_audio_status",
                type: status,
                targetUser: student,
                error: error?.message || error,
              },
            });
          });
        return;
      } else {
        // student.audio_state = status === 2;
        this.handleRemoteAudio(student.user_id, status)
          .then(() => {
            student.audioLoading = false;
            if (status === 2) {
              student.audio_state = status;
            }
            uploadLiveLog({
              message:
                status === 1
                  ? "打开某人麦克风权限成功"
                  : "关闭某人麦克风权限成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_audio_status",
                type: status,
                targetUser: student,
              },
            });
          })
          .catch((error) => {
            student.audioLoading = false;
            uploadLiveLog({
              message:
                status === 1
                  ? "打开某人麦克风权限失败"
                  : "关闭某人麦克风权限失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_audio_status",
                type: status,
                targetUser: student,
                error: error?.message || error,
              },
            });
          });
      }
    },
    // 操作某人摄像头
    changeVideoStatus(student) {
      const currentState = this.getVideoState(student);
      let status = 0;
      if (currentState === "disabled" || currentState === "loading") {
        return;
      } else if (currentState === "open") {
        status = 2;
      } else if (currentState === "close") {
        status = 1;
      }
      this.$set(student, "videoLoading", true);
      //   如果当前用户是老师，操作自己的摄像头 或者当前用户是助教操作自己的麦克风 直接更新状态就行
      if (
        student.user_id === this.userInfo.user_id &&
        (this.roomInfo.isTeacher || this.roomInfo.isAssistant)
      ) {
        const isMute = status === 2;
        this.handleSelfCamera(isMute)
          .then(() => {
            student.video_state = status;
            student.videoLoading = false;
            uploadLiveLog({
              message:
                status === 1 ? "打开自己摄像头成功" : "关闭自己摄像头成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_video_status",
                type: status,
                targetUser: student,
              },
            });
          })
          .catch((error) => {
            console.error("操作自己摄像头失败:", error);
            student.videoLoading = false;
            uploadLiveLog({
              message:
                status === 1 ? "打开自己摄像头失败" : "关闭自己摄像头失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_video_status",
                type: status,
                targetUser: student,
                error: error?.message || error,
              },
            });
          });
        return;
      } else {
        this.handleRemoteVideo(student.user_id, status)
          .then(() => {
            student.videoLoading = false;
            if (status === 2) {
              student.video_state = status;
            }
            uploadLiveLog({
              message:
                status === 1
                  ? "打开某人摄像头权限成功"
                  : "关闭某人摄像头权限成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_video_status",
                type: status,
                targetUser: student,
              },
            });
          })
          .catch((error) => {
            student.videoLoading = false;
            uploadLiveLog({
              message:
                status === 1
                  ? "打开某人摄像头权限失败"
                  : "关闭某人摄像头权限失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "change_video_status",
                type: status,
                targetUser: student,
                error: error?.message || error,
              },
            });
          });
      }
    },
    // 操作移入学生
    handleMoveInStudent(student) {
      if (student.moveInLoading) return;
      this.$set(student, "moveInLoading", true);
      removeUser({
        user_id: student.user_id,
        room_id: this.roomInfo.id,
        is_permanent_remove: undefined,
        action: 1,
      })
        .then((res) => {
          if (res.code === 1) {
            student.is_permanent_remove = 2;
            this.$darkMessage.success("该学员已解除限制，可再次进入直播间");
          } else {
            this.$darkMessage.error(res.message);
          }
        })
        .catch((error) => {
          this.$darkMessage.error(error.message);
          uploadLiveLog({
            message: "移入学生失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              error: error?.message || error,
            },
          });
        })
        .finally(() => {
          this.$set(student, "moveInLoading", false);
        });
    },
    // 移除学生成功
    onMoveOutSuccess(isNeverJoinAgain) {
      this.batchUpdater.queue(this.handleStudentData.user_id, {
        is_permanent_remove: isNeverJoinAgain ? 1 : 2,
        status: 0,
      });
    },
    // 获取房间信息
    async getRoomInfo() {
      try {
        let { code, data, message } = await getRoomInfo({
          room_id: this.roomInfo.id,
        });
        if (code === 1) {
          data.isTeacher = isTeacher(this.userInfo.user_id, data);
          data.isAssistant = isAssistant(this.userInfo.user_id, data);
          this.setRoomInfo(data || {});
        } else {
          this.$darkMessage.error(message);
          uploadLiveLog({
            message: "获取房间信息失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              error: message,
            },
          });
        }
      } catch (error) {
        this.$darkMessage.error(error.message);
        uploadLiveLog({
          message: "获取房间信息失败",
          level: "error",
          tag: "userAction",
          extra: {
            component: "Roster",
            error: error?.message || error,
          },
        });
      }
    },
    // 数组去重
    removeDuplicate(list) {
      const seen = new Map();
      return list.filter((item) => {
        if (!item || !item.user_id) return false;
        if (seen.has(item.user_id)) {
          return false;
        }
        seen.set(item.user_id, true);
        return true;
      });
    },
    dealListAfterGetData(list) {
      // 去重
      list = this.removeDuplicate(list);
      this.list = list.map((item) => {
        const member = this.allMemberStatusMap[item.user_id];
        if (member) {
          if (member.audio_state !== item.audio_state) {
            item.audio_state = member.audio_state;
          }
          if (member.video_state !== item.video_state) {
            item.video_state = member.video_state;
          }
          if (member.nickname !== item.nickname) {
            item.nickname = member.nickname || item.nickname;
          }
        }
        item.isHandUp = this.showHandup(item);
        // 处理举手问题
        if (item.isHandUp) {
          if (this.handUpTimeoutMap.has(item.user_id)) {
            clearTimeout(this.handUpTimeoutMap.get(item.user_id));
          }
          const timeout = Math.max(
            0,
            10000 - (Date.now() - item.hand_up_time * 1000)
          );
          const userId = item.user_id;
          const timeId = setTimeout(() => {
            this.batchUpdater.queue(userId, {
              isHandUp: false,
            });
            this.handUpTimeoutMap.delete(userId);
          }, timeout);
          this.handUpTimeoutMap.set(item.user_id, timeId);
        }
        return item;
      });
    },
    // 清理举手超时定时器
    clearHandUpTimeoutMap() {
      if (this.handUpTimeoutMap) {
        this.handUpTimeoutMap.forEach((timeId) => {
          clearTimeout(timeId);
        });
        this.handUpTimeoutMap.clear();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.comp-container__roster ::v-deep {
  width: 480px;
  height: 520px;
  display: flex;
  flex-direction: column;
  background: #18181b;
  // box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 2px solid #27272a;
  .el-drawer__body {
    display: flex;
    flex-direction: column;
  }
  .roster-drawer__title {
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #27272a;
    position: relative;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .roster-drawer__search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-bottom: 1px solid #27272a;
    height: 64px;
    .search-box {
      width: 210px;
      height: 32px;
      background: #27272a;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px 10px 10px 10px;
      display: flex;
      align-items: center;
      padding: 0 14px;
      i {
        font-size: 17px;
        color: #a1a1aa;
      }
      .el-input {
        border: none;
        height: 100%;
        .el-input__inner {
          height: 100%;
          background: transparent;
          border: none;
          color: #c9cdd4;
          padding: 0 4px;
        }
      }
    }
    .handle-box {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-left: 12px;
        cursor: pointer;
      }
    }
  }
  .roster-drawer__content {
    flex: 1;
    padding: 0 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .row {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #c9cdd4;
      font-weight: 500;
      font-size: 14px;
      padding: 0 6px;
      &.title {
        min-height: 40px;
      }
      &.offline {
        color: #4e5969;
        .col {
          img {
            cursor: not-allowed;
          }
        }
      }
      .col {
        margin-right: 11px;
        flex: 1;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
      .device {
        max-width: 16px;
        margin-right: 11px;
        img {
          width: 16px;
          height: 16px;
        }
      }
      .name {
        flex: 4;
        display: flex;
        img {
          width: 20px;
          height: 20px;
          margin-left: 6px;
          cursor: pointer;
        }
        .name-text {
          margin-left: 2px;
        }
        .tag {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          min-width: 30px;
          height: 20px;
          background: #001731;
          font-weight: 500;
          font-size: 12px;
          color: #006fee;
          border-radius: 8px 8px 8px 8px;
          &.teacher-tag {
            background: #052814;
            color: #17c964;
          }
        }
      }
    }
    .list-box {
      flex: 1;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 0;
      }
      .row {
        &:nth-child(2n + 1) {
          background: rgba(217, 217, 217, 0.02);
          border-radius: 6px 6px 6px 6px;
        }
      }
      .empty {
        img {
          width: 150px !important;
        }
        color: #c9cdd4 !important;
      }
    }
    .el-loading-mask {
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(7px);
    }
    .el-loading-spinner {
      display: flex;
      justify-content: center;
      .path {
        stroke: #006fee;
      }
    }
  }
}
.comp-container__roster__screen-share {
  .roster-drawer__content {
    .col.whiteboard {
      min-width: 55px;
    }
  }
}
.roster-dropdown-menu ::v-deep {
  width: 128px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 0;
  .popper__arrow {
    display: none;
  }
  li {
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    height: 36px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      background: transparent;
      color: #ecedee;
    }
  }
  .remove {
    &:hover {
      color: #f53f3f;
    }
  }
}
</style>
